export default __webpack_public_path__ + "static/educaLenguaje-a50116127007b603bb1d90758464c3c2.jpeg";